export default "__VITE_ASSET__CiYKNzeO__"